import { createContext, use, useState } from 'react';
import { createPortal } from 'react-dom';

const context = createContext<HTMLDivElement | null | undefined>(undefined);

export function MicrositePortalProvider({ children }: { children: React.ReactNode }) {
	const [ref, setRef] = useState<HTMLDivElement | null>(null);

	return (
		<context.Provider value={ref}>
			{children}
			<div
				ref={(el) => {
					setRef(el);
				}}
			/>
		</context.Provider>
	);
}

export default function MicrositePortal({ children }: { children: React.ReactNode }) {
	const ref = use(context);

	if (ref === undefined) {
		throw new Error('MicrositePortal must be used within a MicrositePortalProvider');
	}

	if (ref === null) {
		return null;
	}

	return createPortal(children, ref);
}
